import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { DataGrid as DataGridMui } from '@material-ui/data-grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { localText } from '../../langs/fa/data-grid';
import { Pagination } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
  items: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
    '& > div': {
      display: 'grid',
      gridTemplateColumns: '2fr 4fr',
      gridGap: theme.spacing(1),
    },
    '& > div > span:first-child': {
      color: theme.palette.primary.light,
    },
  },
}));

export const DataGrid = (props) => {
  const classes = useStyles();
  const [rows, setRows] = useState([]);

  const handleRowSelect = (rowId) => {
    if (rows.includes(rowId)) {
      const newRows = rows.filter((row) => row !== rowId);
      setRows(newRows);
      props.onSelectionChange({ rowIds: newRows });
    } else {
      setRows([...rows, rowId]);
      props.onSelectionChange({ rowIds: [...rows, rowId] });
    }
  };
  const handleToggleSelectAll = () => {
    const _rows = props.rows?.map((row) => row.id);
    if (rows.length === _rows?.length) {
      setRows([]);
      props.onSelectionChange({ rowIds: [] });
    } else {
      setRows(_rows);
      props.onSelectionChange({ rowIds: _rows });
    }
  };
  function handleChangePage(page) {
    props.onPageChange(page);
    isMobile && window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  let components = {};
  props.components && (components = { ...components, ...props.components });
  props.footerPagination &&
    (components = {
      ...components,
      Pagination: () => (
        <Pagination
          count={props.totalPages}
          page={props.pageNumber || props.defaultPage}
          onChange={(_, page) => props.onPageChange(page)}
        />
      ),
    });

  return isMobile ? (
    <div className={classes.root}>
      {isMobile && props?.hasSelectAll && (
        <Button
          variant="outlined"
          fullWidth
          color="primary"
          onClick={handleToggleSelectAll}
          endIcon={<ExpandMoreIcon />}
        >
          انتخاب همه
        </Button>
      )}
      {props.rows?.map((row) => (
        <Card
          key={row.id}
          style={{ background: rows.includes(row.id) ? '#efefef' : '#fff' }}
        >
          <CardActions
            onClick={() =>
              props?.onSelectionChange
                ? handleRowSelect(row.id)
                : props?.onCellClick({ row, field: '' })
            }
          >
            <div className={classes.items}>
              {props.columns?.map((column) => (
                <div key={column.field}>
                  {column?.headerName && <span>{column.headerName}: </span>}
                  <span>
                    {column?.renderCell
                      ? column.renderCell({ value: row[column.field] })
                      : row[column.field]}
                  </span>
                </div>
              ))}
            </div>
          </CardActions>
        </Card>
      ))}
      {props.rows.length > 0 && (
        <Pagination
          count={props.totalPages}
          page={props.pageNumber || props.defaultPage}
          onChange={(_, page) => handleChangePage(page)}
        />
      )}
    </div>
  ) : (
    <>
      <DataGridMui {...props} components={components} localeText={localText} />
    </>
  );
};

export default React.memo(DataGrid);
